<template>
  <div>
    <el-dialog
      :visible.sync="docsDialogVisible"
      width="45%"
      :before-close="docsDialogClose"
      :append-to-body="true"
      :modal-append-to-body="false"
      custom-class="handlian-copy-tree"
    >
      <div class="docs-dia-content">
        <div>
          <div style="font-weight: bold;">导出说明</div>
          <div>
            建议使用<a
              class="link-text"
              href="https://www.google.cn/chrome/"
              target="_blank"
              >谷歌浏览器</a
            >导出家谱（族谱）文件。
          </div>
          <!-- <div>
            <p>一、“导出.png 图片”，即可下载家谱（族谱）图片。</p>
          </div> -->
          <div>
            <p>
              一、点击“隐藏导出按钮”选项，通过浏览器打印功能导出。此时“导出家谱”按钮将会被隐藏，刷新页面可恢复。下面以“谷歌浏览器”举例。
            </p>
            <div>
              <p>
                1.1
                点击浏览器右上角“三点标志”，打开菜单。在弹出的列表中选择“打印”选项。
              </p>
              <div>
                <el-image
                  :src="docImage[0]"
                  :lazy="true"
                  class="exp-doc-image"
                  @click="handlePreview(0)"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
            <div>
              <p>
                1.2 点击“打印”后，弹出的窗口可以预览pdf文件，首先“目标打印机”
                →选择
                “另存为PDF”；其次点击“保存”。如果预览时出现空白页，可展开“更多设置”调整纸张尺寸。
              </p>
              <div>
                <el-image
                  :src="docImage[1]"
                  :lazy="true"
                  class="exp-doc-image"
                  @click="handlePreview(1)"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
            <div>
              <p>
                1.3 最后保存家谱（族谱）文件到您的电脑上。
              </p>
              <div>
                <el-image
                  :src="docImage[2]"
                  :lazy="true"
                  class="exp-doc-image"
                  @click="handlePreview(2)"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </div>
        </div>
        <div style="text-align:center">
          <span slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              size="small"
              @click="docsDialogVisible = false"
              >确 定</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import doc1 from "../../../../public/image/cl_export_doc_1.png";
import doc2 from "../../../../public/image/cl_export_doc_2.png";
import doc3 from "../../../../public/image/cl_export_doc_3.png";
export default {
  name: "export-tree-explain",
  data() {
    return {
      docsDialogVisible: false,
      docImage: [doc1, doc2, doc3],
    };
  },
  methods: {
    docsDialogClose(done) {
      done();
    },
    handlePreview(index) {
      try {
        window.open(this.docImage[index]);
      } catch (error) {}
    },
    onSwitch() {
      this.docsDialogVisible = true;
    },
  },
};
</script>
<style scoped>
.docs-dia-content {
  padding: 10px 10px;
  line-height: 24px;
  font-size: 16px;
}

.exp-doc-image {
  width: 300px;
  height: 150px;
}

.link-text {
  margin: 0 3px;
  color: #1a70db;
}
</style>
